import { DeleteEmployeeResponseDTO } from '@/core/dto/psychosocial-report';
import type { DeleteEmployeeResponse } from '@/types/Psychosocial';

export class DeleteEmployeeMapper {
	constructor(private readonly data: DeleteEmployeeResponseDTO) {}

	toDomain(): DeleteEmployeeResponse {
		return {
			status: this.data.status,
			message: this.data.message
		};
	}
}
